import { isIsoDateTime } from '../validation/is-iso-date-time.function';
import { isIsoDateTimeTz } from '../validation/is-iso-date-time-tz.function';
import { isIsoTime } from '../validation/is-iso-time.function';
import { isIsoTimeTz } from '../validation/is-iso-time-tz.function';
import type { IsoDateTime, IsoDateTimeTz, IsoTime, IsoTimeTz } from '../../types/iso-date';
import { deconstructDate } from '../helper/deconstruct-date.function';

/**
 * Extracts the milliseconds component (0-999) from an ISO 8601 time or date-time string.
 *
 * Supported inputs:
 * - Date-time (no tz): YYYY-MM-DDTHH:mm:ss(.fraction[1-6])?
 * - Date-time with tz: YYYY-MM-DDTHH:mm:ss(.fraction[1-6])?(Z|±HH:MM)
 * - Time-only (no tz): HH:mm:ss(.fraction[1-6])?
 * - Time-only with tz: HH:mm:ss(.fraction[1-6])?(Z|±HH:MM)
 *
 * Fractional seconds handling matches repository convention:
 * - 0 digits -> 0 ms
 * - 1-2 digits -> pad right with zeros to 3 digits (e.g., .1 => 100, .12 => 120)
 * - 3+ digits -> take the first 3 digits (truncate, e.g., .1234 => 123)
 *
 * Throws if the input is not a valid ISO time/date-time (date-only strings are not supported).
 */
export function getMillisecond(input: IsoDateTime | IsoDateTimeTz | IsoTime | IsoTimeTz): number {
  const { milliseconds } = deconstructDate(input);
  if(milliseconds === undefined)
    throw new Error('getMillisecond: invalid ISO time/date-time string');
  return milliseconds;
}

